import { IUser } from '../Interfaces/IUser';
import { IAction } from '../../../__core/Interfaces/IAction';
import APP_ACTIONS from '../Actions/ActionTypes';
import { userInitState } from './AppInitState';

export const userReducer = (
  state: IUser = userInitState,
  action: IAction<IUser>
): IUser => {
  switch (action.type) {
    case APP_ACTIONS.FETCH_USER:
      return { ...action.payload };

    default:
      return state;
  }
};
